module.exports = __webpack_public_path__ + "static/media/chat.a96eeb8e.svg";